/**
 * Sprint P32 · Section-slicer plane visualisation (local scene space).
 */
import * as THREE from "three";
import { worldToScene } from "@/lib/sceneCoords";


export function SlicerPlane({ slicer, slicerPos, worldBBox, origin, verticalExaggeration }) {
  if (slicer === "off" || !worldBBox || !origin) return null;
  const { xMin, xMax, yMin, yMax, zMin, zMax } = worldBBox;
  const centre = worldToScene(
    (xMin + xMax) / 2, (yMin + yMax) / 2, (zMin + zMax) / 2,
    origin, verticalExaggeration,
  );
  const width  = Math.abs(yMax - yMin);
  const height = Math.abs(zMax - zMin) * verticalExaggeration;
  const depth  = Math.abs(xMax - xMin);
  if (slicer === "ns") {
    const localSlicer = slicerPos - origin.easting;
    return (
      <mesh position={[localSlicer, centre.y, centre.z]}>
        <planeGeometry args={[width, height]} />
        <meshBasicMaterial color="#38BDF8" transparent opacity={0.15}
                            side={THREE.DoubleSide} />
      </mesh>
    );
  }
  if (slicer === "ew") {
    const localSlicer = -(slicerPos - origin.northing);
    return (
      <mesh position={[centre.x, centre.y, localSlicer]}
            rotation={[0, Math.PI / 2, 0]}>
        <planeGeometry args={[depth, height]} />
        <meshBasicMaterial color="#F472B6" transparent opacity={0.15}
                            side={THREE.DoubleSide} />
      </mesh>
    );
  }
  return null;
}
